import Vue from 'vue';
import Vuex from 'vuex';
import auth from './modules/auth';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    alert: {
      status: '',
      show: false,
      message: '',
    },
    isLoading: false,
  },
  actions: {
    setAlert({ commit }, alert) {
      commit('updateAlert', alert);
    },
    setLoading({ commit }, loading) {
      commit('updateLoading', loading);
    },
  },
  mutations: {
    updateAlert(state, alert) {
      state.alert = Object.assign({ status: 'success', show: true }, alert);
    },
    updateLoading(state, loading) {
      state.isLoading = loading;
    },
  },
  modules: {
    auth, // auth namespaced
  },
});